import React from 'react'

const StreamingSoonIcon = ({ color = '#fff' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.5" viewBox="0 0 16.5 16.5">
      <g transform="translate(-.75 -.75)">
        <circle
          data-name="Ellipse 99"
          cx="7.5"
          cy="7.5"
          r="7.5"
          transform="translate(1.5 1.5)"
          style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, strokeWidth: '1.5px' }}
        />
        <circle
          data-name="Ellipse 100"
          cx="7.5"
          cy="7.5"
          r="7.5"
          transform="translate(1.5 1.5)"
          style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, strokeWidth: '1.5px' }}
        />
        <circle
          data-name="Ellipse 101"
          cx=".671"
          cy=".671"
          r=".671"
          transform="translate(8.245 8.245)"
          style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, strokeWidth: '1.5px' }}
        />
        <path
          data-name="Line 126"
          transform="translate(8.916 3.52)"
          style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, strokeWidth: '1.5px' }}
          d="M0 0v4.725"
        />
        <path
          data-name="Line 127"
          transform="translate(9.587 9.587)"
          style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, strokeWidth: '1.5px' }}
          d="M2.698 2.698 0 0"
        />
      </g>
    </svg>
  )
}

export default StreamingSoonIcon
